import { SearchFilters } from "@outschool/gql-backend-generated";

import { CardDefinition, ListRenderableCard } from "../CardDefinition";

export const type = "times";

export type PreferredTimesCardDefinition = CardDefinition & {
  title: string;
  url: string;
  searchFilters: SearchFilters;
  imageUrl: null;
};

export function getListRenderData(argument: string): ListRenderableCard {
  const card = definitions.find(d => d.id === argument);
  // @ts-ignore TS(2532): Object is possibly 'undefined'.
  return { ...card, showMoreUrl: card.url, listings: null };
}

export const PREFERRED_TIME_TITLE = Object.freeze({
  AFTERSCHOOL: "Great afterschool classes",
  DAYTIME: "Greate daytime classes",
  WEEKEND: "Great weekend classes"
});

export const definitions: PreferredTimesCardDefinition[] = [
  {
    type,
    id: "afterschool",
    title: PREFERRED_TIME_TITLE.AFTERSCHOOL,
    searchFilters: {
      startAfterTime: 14,
      endByTime: 18
    },
    url: "/dashboard/times/afterschool",
    imageUrl: null
  },
  {
    type,
    id: "daytime",
    title: PREFERRED_TIME_TITLE.DAYTIME,
    searchFilters: {
      startAfterTime: 8,
      endByTime: 15
    },
    url: "/dashboard/times/daytime",
    imageUrl: null
  },
  {
    type,
    id: "weekend",
    title: PREFERRED_TIME_TITLE.WEEKEND,
    searchFilters: {
      dow: "Sat,Sun"
    },
    url: "/dashboard/times/weekend",
    imageUrl: null
  }
];
